import React from 'react';
import { Expand } from 'styled-icons/boxicons-regular/Expand';

function ExpandIcon(props) {
  return (
    <Expand {...props} className={'icon'} />
  );
}

export default ExpandIcon;
